// extracted by mini-css-extract-plugin
export default {"modal_container":"NewUserModal_modal_container__hcDVU","modal_body":"NewUserModal_modal_body__Lum5s"};